
  <div class="testing-page-wrap">
  <div class="testing-header">
    @if(!isFinished()){
      <div class="back-button-header" (click)="setModal()">
        <button class="back-button__button">
          <img src="assets/icons/arrow.svg" class="course-icon arrow-left" alt="arrow">
          <span class="back-button__text din-pro-condensed">Назад</span>
        </button>
      </div>
    }@else{
          <back-button   [routerLink] ="navigateTesting()"></back-button>
    }


    <div class="testing-pagination-wrap">
        @for (number of dinamicData(); track $index; let i = $index) {
          <button   class="button-pagination din-pro-condensed "
                    [class.active]="i === questionNumber()"
                    [class.disable]="i !== questionNumber()"
          >{{i + 1}}</button>
        }
      </div>
  </div>
      <div class="testing-page-question-wrap">
        <h1 class="testing-page-question__title din-pro-condensed ">{{dinamicData()![questionNumber()]?.title}}</h1>
        @if (testingForm && dinamicData().length > 0 && dinamicData()[questionNumber()]){
          <form class="testing-page-question__form" [formGroup]="testingForm" >
            @for (item of dinamicData()![questionNumber()]!.options; track item.id){
              <label class="testing-wrap-items">
                <p-radioButton
                  [id]="item.id"
                  name="item.id"
                  [formControlName]="item.controlName"
                  [value]="item.value">
                </p-radioButton>
                <span     class="course-answer-item din-pro-simple-text "> {{ item.label }}</span>
              </label>
            }
          </form>
        }
      </div>
    <div class="custom-arrows custom-arrow-background">
      <div  (click)="prevQuestion()"
            class="arrow prev swiper-prev swiper-button-prev"
            [class.disabled]="questionNumber() === 0"
            style="transform: rotate(180deg);"></div>
       <button (click)="checkResult()"    [disabled]="!isLastQuestion() || testingForm.invalid" class="button active">Проверить</button>
      <div
        (click)="nextQuestion()"
        [class.disabled]="!testingForm ||testingForm.get(currentControlName)?.invalid ||isLastQuestion()"
             class="arrow next swiper-next swiper-button-next"></div>
    </div>
  </div>


  @if(isModal()){
    <confirmation-modal
      [typeImage]="'testNotFinished'"
      [textModal]="'тест не завершен. \nвы уверены, что хотите выйти?'">
      <div class="modal-lesson-buttons">
        <button class="button" (click)="toTest()">Назад</button>
        <button class="button active"  (click)="skipButton()">Выйти</button>
      </div>
    </confirmation-modal>
  }
